import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(33.00000, 29.000000)">
        <path
          d="M 33.7 34.65 L 26.9 34.65 Q 26.2 32.6 25.45 30.6 Q 24.7 28.6 24 26.5 L 9.4 26.5 Q 8.7 28.6 7.975 30.625 Q 7.25 32.65 6.55 34.65 L 0 34.65 Q 1.95 29.1 3.7 24.4 A 447.951 447.951 0 0 1 5.431 19.825 A 383.513 383.513 0 0 1 7.125 15.5 A 297.197 297.197 0 0 1 9.623 9.425 A 260.362 260.362 0 0 1 10.45 7.5 Q 12.1 3.7 13.85 0 L 19.8 0 Q 21.55 3.7 23.2 7.5 A 278.32 278.32 0 0 1 25.689 13.425 A 317.019 317.019 0 0 1 26.525 15.5 Q 28.2 19.7 29.975 24.4 Q 31.75 29.1 33.7 34.65 Z M 11 21.4 L 22.4 21.4 Q 20.8 16.95 19.3 13.1 Q 17.836 9.343 16.753 6.824 A 106.369 106.369 0 0 0 16.7 6.7 A 130.388 130.388 0 0 0 15.792 8.849 Q 15.394 9.812 14.965 10.887 A 255.168 255.168 0 0 0 14.075 13.15 A 314.837 314.837 0 0 0 12.569 17.112 A 393.309 393.309 0 0 0 11 21.4 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
